module.exports = __webpack_public_path__ + "img/HeavyHanded.0f1fb2b5.png";